import React from "react";

/**
 * EmptyState — reusable zero-state card for list views.
 *
 * Pattern: large emoji/icon → bold heading → muted explainer → optional
 * primary action button. Designed to feel inviting rather than dead-end —
 * empty lists are the FIRST impression for most new tradies.
 *
 * @param {Object}   props
 * @param {string}   [props.icon="📋"]    Emoji or short string rendered large
 * @param {string}   props.title          Bold one-liner
 * @param {string}   [props.description]  Smaller muted explainer
 * @param {Object}   [props.action]       Optional CTA: { label, onClick }
 * @param {Object}   [props.style]        Extra style overrides on the wrapper
 */
export default function EmptyState({
  icon = "📋",
  title,
  description,
  action,
  style,
}) {
  return (
    <div
      className="empty-state"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        padding: "36px 20px",
        ...style,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          fontSize: "2.6rem",
          lineHeight: 1,
          marginBottom: "14px",
          opacity: 0.92,
        }}
      >
        {icon}
      </div>
      {title && (
        <div
          style={{
            fontSize: "1.05rem",
            fontWeight: 700,
            color: "var(--text)",
            marginBottom: description ? "6px" : "0",
          }}
        >
          {title}
        </div>
      )}
      {description && (
        <div
          className="muted small"
          style={{
            maxWidth: "480px",
            margin: "0 auto",
            lineHeight: 1.55,
          }}
        >
          {description}
        </div>
      )}
      {action && action.onClick && (
        <button
          type="button"
          className="btn btn-primary"
          onClick={action.onClick}
          style={{ marginTop: "18px" }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
